import { LoaderCircle } from "lucide-react";

type LoadingStateProps = {
  title: string;
  description?: string;
  className?: string;
};

/** 营销风格加载反馈，适用于列表、弹窗和数据面板。 */
export function LoadingState({ title, description = "正在同步最新数据，请稍候...", className = "" }: LoadingStateProps) {
  return <div className={`fm-shadcn-loading-state ${className}`.trim()} role="status" aria-live="polite">
    <LoaderCircle className="fm-shadcn-loading-icon" aria-hidden="true" />
    <div className="fm-shadcn-loading-copy"><strong>{title}</strong><span>{description}</span></div>
  </div>;
}
